import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg
      width="6"
      height="3"
      viewBox="0 0 6 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.89111 0L5.48919 3H0.293037L2.89111 0Z" fill="#8E8E8E" />
    </svg>
  );
};

export default Svg;
